import { CSSProperties, ReactNode } from "react";

export interface NumberIntervalProps {
  /** 值 */
  value?: NumberIntervalValueType[];
  /** 默认值，仅在初始化时有效 */
  defauleValue?: NumberIntervalValueType[];
  /** 区间分割的文字 */
  splitText?: string;
  /** 是否禁用 */
  disabled?: boolean;
  /** 禁用是显示内容 */
  disabledRender?: ReactNode;
  /** 禁用文字溢出隐藏 */
  disabledEllipsis?: boolean;
  /** 禁用文字下边框虚线 */
  disabledBorder?: boolean;
  /** 数字单位 */
  unit?: string;
  /** 值改变回调 */
  onChange?: (value?: NumberIntervalValueType[]) => void;
}

export type NumberIntervalValueType = number | undefined;

/** 数字输入框公共样式 */
export const inputNumberStyle: CSSProperties = { width: '100%' };
